// export const darkTheme = {
//     bg:"#1C1C27",
//     bgLight: "#1C1E27",
//     primary:"#854CE6",
//     text_primary:"#F2F3F4",
//     text_secondary:"#b1b2b3",
//     card:"#171721",
//     card_light: '#191924',
//     button:"#854CE6",
//     white:"#FFFFFF",
//     black:"#000000",
// }

// export const lightTheme = {
//     bg:"#FFFFFF",
//     bgLight: "#f0f0f0",
//     primary:"#be1adb",
//     text_primary:"#111111",
//     text_secondary:"#48494a",
//     card:"#FFFFFF",
//     button:"#5c5b5b",
// }


export const darkTheme = {
  mainBg: "#151724",
  cardBg: "#202235",
  text: "#fff", // <-- white text for dark mode!
  secondaryText: "#aaa",
  accent2: "#ffcb05",
  chipBg: "#393b56",
  chipText: "#d3cdfa",
  navBg: 'rgba(0, 0, 0, 0.6)',
  bg: "#1C1C27",
  bgLight: "#1C1E27",
  primary: "#854CE6",
  accent: "#A27AFF",
  text_primary: "#F2F3F4",
  text_secondary: "#B1B2B3",
  card: "#171721",
  card_light: "#191924",
  button: "#854CE6",
  toggle_bg: "#312F45",
  toggle_text: "#C8C8E4",
  toggle_border: "#544D7A",
  toggle_hover_bg: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
  footerBackground: "#00012B",
};

export const lightTheme = {
  navBg: 'rgba(255, 255, 255, 0.1)',
  bg: "#FFFFFF",
  bgLight: "#F0F0F0",
  primary: "#BE1ADB",
  accent: "#E667FF",
  text_primary: "#111111",
  text_secondary: "#48494A",
  card: "#FFFFFF",
  card_light: "#F8F8F8",
  button: "#5C5B5B",
  toggle_bg: "#E0E0E5",
  toggle_text: "#555555",
  toggle_border: "#CCCCCC",
  toggle_hover_bg: "#BE1ADB",
  white: "#FFFFFF",
  black: "#000000",
  footerBackground: "#F2F2F2",
};

export const starTheme = {
  mainBg: "#0A0C20",  // Dark background for the star effect
  cardBg: "#202235",
  text: "#fff", 
  secondaryText: "#aaa",
  accent2: "#ffcb05",
  chipBg: "#393b56",
  chipText: "#d3cdfa",
  navBg: 'rgba(0, 0, 0, 0.6)',
  bg: "#0A0C20",  // Darker background for star theme
  bgLight: "#1C1E27",
  primary: "#854CE6",
  accent: "#A27AFF",
  text_primary: "#F2F3F4",
  text_secondary: "#B1B2B3",
  card: "#171721",
  card_light: "#191924",
  button: "#854CE6",
  toggle_bg: "#312F45",
  toggle_text: "#C8C8E4",
  toggle_border: "#544D7A",
  toggle_hover_bg: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
  footerBackground: "#00012B",
  starEffect: true,  // Add a flag to enable the star effect
};
